import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import useQuoteModal from '../useQuoteModal';
import ItemType from '../ItemType';
import { SUB_MENU_LIST } from '../../constants/MenuItemTypes';
import { moneyFormat, requiredItemsLabel, isRequirementUnmet, remainingMenuRequirements, menuRequirementLabel } from '../../services/product';
import ListView from './ListView';
import {updateCateringMinimumSpend} from "../../redux/actions/rules";
import {OPEN_MENU} from "../../redux/quote";


function SubMenu({ item, dispatch, quote, config }) {
  const [modalVisible, showModal] = useQuoteModal(false);
  let items = _.orderBy(
    _.filter(quote.menu, { parent_id: item.id }),
    '_lft',
  );

  const remaining = remainingMenuRequirements(item, quote.menu);


  const selectMenu = () => {
    dispatch(updateCateringMinimumSpend());
    showModal(false);
  };

  const openMenu = () => {
    showModal(true);
    dispatch({
      type: OPEN_MENU,
      payload: { item: item },
    });
  };

  const removeMenu = () => {
    dispatch({
      type: 'REMOVE_MENU',
      payload: { item: item },
    });

    showModal(false);
  };
  const price = (config.showFullPrice) ? item.total : item.unit_price;
  const modal = () => (
    <Modal
    show={ modalVisible }
    onHide={() => showModal(false)}
    aria-labelledby={`menu-title-${item.id}`}
    className="quote-dialog"
    size="lg"
    centered
    >
      <Modal.Header>
        <h2 id={`menu-title-${item.id}`}>{item.label}</h2>
        <button type="button" className="dialog-close" aria-label="Close menu" onClick={() => showModal(false)}>×</button>
      </Modal.Header>

        <Modal.Body className={'modal-text'}>
          {(!_.isNull(item.minimum_choices) && item.minimum_choices > 0 && isRequirementUnmet(item, quote.menu)) &&
            <div className="mb-3 text-end">
              <span className="badge badge-warning me-1">{requiredItemsLabel(item)}</span>
            </div>
          }
          {
          items.map((i) => (
            (item.menu_item_type_id === SUB_MENU_LIST) ? <ListView item={i} key={i.id} /> : <ItemType item={i} key={i.id} />
          ))
          }

        </Modal.Body>
        <Modal.Footer>
          <div className="menu-requirements" id={`menu-requirements-${item.id}`} role="status" aria-live="polite" aria-atomic="true">
            {remaining.length > 0 ? <>
              <p>Before you finish this menu:</p>
              <ul>
                {remaining.map((requirement) => <li key={requirement.item.id}>
                  <button type="button" className="requirement-link" onClick={() => {
                    const target = document.getElementById(`menu-group-title-${requirement.item.id}`) || document.getElementById(`MenuItem${requirement.item.id}`);
                    if (target) {
                      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      target.focus({ preventScroll: true });
                    }
                  }}>{menuRequirementLabel(requirement)}</button>
                </li>)}
              </ul>
            </> : <p>Required choices complete. You can finish this menu.</p>}
          </div>
          <button type="button" className="btn btn-secondary" onClick={removeMenu}>Remove Menu</button>
          <button type="button" className="btn btn-primary" disabled={remaining.length > 0}
            aria-describedby={`menu-requirements-${item.id}`} onClick={selectMenu}>
            Done
          </button>
        </Modal.Footer>
      </Modal>
      );


  return (
    <React.Fragment>
      {modal()}
      <div id={'MenuItem' + item.id}>
        <button
          type="button"
          aria-haspopup="dialog"
          aria-pressed={!!item.selected}
          onClick={() => openMenu()}
          className={`blockCard ${(item.selected ? 'selected' : '')} ${(item.is_disabled ? ' disabled' : '')}`}
        >
          <div className="block-title row">
            <div className="col-6">
              {item.label}
            </div>
            <div className="col-6 text-end">
              {(!_.isNull(item.minimum_choices) && item.minimum_choices > 0 && isRequirementUnmet(item, quote.menu)) && <span className="badge badge-warning me-1">{requiredItemsLabel(item)}</span>}
              {(price > 0) ? `+ ${moneyFormat(price)}` :''}
            </div>
          </div>
          {item.description &&
            <div className="row">
              <div className="col-12">
                <div className="block-description">{item.description}</div>
              </div>
            </div>
          }
        </button>
      </div>

    </React.Fragment>
  );
}
SubMenu.propTypes = {
  item: PropTypes.object,
  quote: PropTypes.object,
  config: PropTypes.object,
  dispatch: PropTypes.func
};

const mapStateToProps = function (state) {
  return {
    quote: state.quote,
    config: state.config,
  };
};

export default connect(mapStateToProps)(SubMenu);
